import React from 'react';
// import {ReactComponent as YoloLoading} from '../assets/images/loading.svg';
import ReactLoading from 'react-loading';


const Loader = () => 
<ReactLoading type={'spinningBubbles'} color={'#2AA1DA'} />

export default Loader;
